import { ISeatInfo } from "@/domain/entities/book";
import { IResultData } from "@/domain/entities/shared/result";
import TYPES from "@/ioc/identifiers";
import { IBookRepository } from "@/repositories/book/bookRepository.types";
import useSetResultCodeIfNeeded from "@/use/useSetResultCodeIfNeeded";
import { inject, injectable } from "inversify";

export interface ISeatLayoutResult {
  seatLayout: ISeatInfo[][];
  numberOfRows: number[];
  numberOfColumns: number[];
}

export interface GetSeatLayoutUseCase {
  execute(
    turnId: string,
    date: string,
    isMonthlyBook: boolean,
    allocUid?: string
  ): Promise<IResultData<ISeatLayoutResult>>;
}

@injectable()
export class GetSeatLayout implements GetSeatLayoutUseCase {
  constructor(
    @inject(TYPES.IBookRepository) private bookRepository: IBookRepository
  ) {}

  async execute(
    turnId: string,
    date: string,
    isMonthlyBook: boolean,
    allocUid?: string
  ): Promise<IResultData<ISeatLayoutResult>> {
    const seatsInfosResult: IResultData<ISeatLayoutResult> = {
      isSuccess: false,
    };

    await this.bookRepository
      .getSeatsInfos(turnId, date, isMonthlyBook, allocUid)
      .then((result) => {
        result
          .map((seatsInfos) => {
            seatsInfosResult.isSuccess = true;
            seatsInfosResult.data = this.handleSeatLayout(seatsInfos);
          })
          .mapErr((error) => {
            useSetResultCodeIfNeeded(seatsInfosResult, error);
            seatsInfosResult.errorMessage = error.message;
          });
      })
      .catch((error) => {
        seatsInfosResult.isSuccess = false;
        seatsInfosResult.errorMessage = error.message;
      });

    return seatsInfosResult;
  }

  private handleSeatLayout(seats: ISeatInfo[][][]) {
    const seatLayoutResult: ISeatLayoutResult = {
      seatLayout: [],
      numberOfRows: [],
      numberOfColumns: [],
    };

    const zip = (...rows: any[][]) =>
      rows[0].map((_, column) => rows.map((row) => row[column]));

    seats.forEach((info) => {
      let seatsInfos = info;
      seatsInfos = seatsInfos.map((seatsInfo) => seatsInfo.reverse());
      const floorSeatsInfo = zip(...seatsInfos);

      seatLayoutResult.seatLayout.push(floorSeatsInfo.flat());
      seatLayoutResult.numberOfRows.push(floorSeatsInfo.length);
      seatLayoutResult.numberOfColumns.push(floorSeatsInfo[0]?.length ?? 0);
    });

    return seatLayoutResult;
  }
}
